module.exports = __webpack_public_path__ + "media/components/assets/img/logo/testimonials/moja-norwegia-152bbb6fdd143f0a0b1879f1178951d4.png";